import { EventFilter, SaasConnection, SaasProvider, TimeRange } from "../shared/saasTypes";
import { RangeKey } from "../shared/saasFormat";

export interface WorkspaceContext {
    provider: SaasProvider;
    tenantName: string;
    connectionId?: number;
    connections: SaasConnection[];
    range: TimeRange;
    rangeKey: RangeKey;
    openIdentity: (connectionId: number, login: string) => void;
    openResource: (connectionId: number, resourceId: string) => void;
    openEvent: (eventId: number) => void;
    openEvents: (filter: EventFilter) => void;
}

export const singleConnectionId = (context: WorkspaceContext): number | undefined =>
    context.connectionId ?? (context.connections.length === 1 ? context.connections[0].id : undefined);
